<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- Clipboard Graphic in the Floating Tickets Dock -->

<div
	*ngIf="isClipboardEnabled$ | async"
	class="clipboard-in-dock-region"
	[ngClass]="{ disabled: ticketAttachmentsCopyInProgress$ | async }"
>
	<!-- Vertical bar between the scrolling tickets and the clipboard -->
	<div class="clipboard-vertical-separator"></div>

	<!-- "Clipboard" label -->
	<div class="floating-ticket-label clipboard-label">
		{{ clipboardLabel }}
	</div>

	<!-- Clipboard warning icon (Exact Copy mode only) -->
	<div
		*ngIf="showWarningIcon$ | async"
		class="clipboard-warning-button"
		(click)="displayActiveLineMovePrompt()"
	>
		<i class="material-icons clipboard-warning-button">warning</i>
	</div>

	<!-- Clipboard Image -->
	<img class="clipboard-image" [src]="imageSource" />

	<!-- Number of tickets in the clipboard (or empty string if none) -->
	<div class="clipboard-in-dock-count" #clipboardDragAndDropElement automationId="dockTicketCount">
		{{ ticketCountString }}
	</div>

	<!-- Clear clipboard button -->
	<div
		*ngIf="showClearButton$ | async"
		class="clipboard-close-button"
		automationId="closeButton"
		(click)="handleClearButton()"
	>
		<i class="material-icons">cancel</i>
	</div>

	<!-- Paste mode dropdown -->
	<mat-select
		class="paste-mode-menu paste-mode-menu-text"
		[formControl]="selectedModeControl"
		tabindex="-1"
		automationId="pasteMode"
	>
		<mat-option *ngFor="let option of dropdownOptions" [value]="option.value">
			<div class="paste-mode-menu-item" automationId="pasteModeMenuItems">
				{{ option.label }}
				<div class="material-icons menu-warning-button">{{ option.icon }}</div>
			</div>
		</mat-option>
	</mat-select>

	<!-- Menu info icon/button -->
	<div class="clipboard-info-button" (click)="displayPasteModeInfoPopup()" automationId="clipboardInfoButton">
		<i class="icon material-icons">info</i>
	</div>
</div>
